export const LIBRARY_ITEM_PAGE_REQUEST = 'LIBRARY_ITEM_PAGE_REQUEST';
export const LIBRARY_ITEM_LIST_ITEM_REQUEST = 'LIBRARY_ITEM_LIST_ITEM_REQUEST';
export const LIBRARY_ITEM_LIST_CATEGORY_REQUEST =
  'LIBRARY_ITEM_LIST_CATEGORY_REQUEST';
export const LIBRARY_ITEM_LIST_CATEGORY_WITH_UNCATEGORIZED_REQUEST =
  'LIBRARY_ITEM_LIST_CATEGORY_WITH_UNCATEGORIZED_REQUEST';
export const LIBRARY_ITEM_ITEM_SUMMARY_REQUEST =
  'LIBRARY_ITEM_ITEM_SUMMARY_REQUEST';
export const LIBRARY_ITEM_CHANGE_CATEGORY_ID_DROPDOWN =
  'LIBRARY_ITEM_CHANGE_CATEGORY_ID_DROPDOWN';
export const LIBRARY_ITEM_CHANGE_INVENTORY_ID_DROPDOWN =
  'LIBRARY_ITEM_CHANGE_INVENTORY_ID_DROPDOWN';
export const LIBRARY_ITEM_SET_CATEGORY_LIST = 'LIBRARY_ITEM_SET_CATEGORY_LIST';
export const LIBRARY_ITEM_SET_CURRENT_CATEGORY_ID =
  'LIBRARY_ITEM_SET_CURRENT_CATEGORY_ID';
export const LIBRARY_ITEM_SET_ITEM_LIST = 'LIBRARY_ITEM_SET_ITEM_LIST';
export const LIBRARY_ITEM_SET_ITEM_ECOMMERCE_CATEGORY =
  'LIBRARY_ITEM_SET_ITEM_ECOMMERCE_CATEGORY';
export const LIBRARY_ITEM_SET_ITEM_IS_RETAIL =
  'LIBRARY_ITEM_SET_ITEM_IS_RETAIL';
export const LIBRARY_ITEM_SET_ITEM_ECOMMERCE_CATEGORY_FASHION =
  'LIBRARY_ITEM_SET_ITEM_ECOMMERCE_CATEGORY_FASHION';
export const LIBRARY_ITEM_SET_CURRENT_ITEM_ID =
  'LIBRARY_ITEM_SET_CURRENT_ITEM_ID';
export const LIBRARY_ITEM_SET_CURRENT_INVENTORY_ID =
  'LIBRARY_ITEM_SET_CURRENT_INVENTORY_ID';
export const LIBRARY_ITEM_SET_ITEM_SUMMARY = 'LIBRARY_ITEM_SET_ITEM_SUMMARY';
export const LIBRARY_ITEM_SET_OUTLETS = 'LIBRARY_ITEM_SET_OUTLETS';
export const LIBRARY_ITEM_SET_FILTER_STATE = 'LIBRARY_ITEM_SET_FILTER_STATE';
export const LIBRARY_ITEM_SET_FILTER_ITEM = 'LIBRARY_ITEM_SET_FILTER_ITEM';
export const LIBRARY_ITEM_ON_CHANGE_OUTLET_IDS =
  'LIBRARY_ITEM_ON_CHANGE_OUTLET_IDS';
export const LIBRARY_ITEM_SET_CURRENT_PAGE = 'LIBRARY_ITEM_SET_CURRENT_PAGE';
export const LIBRARY_ITEM_SET_TOTAL_PAGE = 'LIBRARY_ITEM_SET_TOTAL_PAGE';
export const LIBRARY_ITEM_ITEMS_REQUEST = 'LIBRARY_ITEM_ITEMS_REQUEST';
export const LIBRARY_ITEM_UNSET_FILTER_STATE =
  'LIBRARY_ITEM_UNSET_FILTER_STATE';
export const LIBRARY_ITEM_ITEM_LIST_EXPORT = 'LIBRARY_ITEM_ITEM_LIST_EXPORT';
export const LIBRARY_ITEM_SET_TYPE_IMPORT = 'LIBRARY_ITEM_SET_TYPE_IMPORT';
export const LIBRARY_ITEM_SHOW_SECTION_UPLOADER =
  'LIBRARY_ITEM_SHOW_SECTION_UPLOADER';
export const LIBRARY_ITEM_ITEM_LIST_TEMPLATE =
  'LIBRARY_ITEM_ITEM_LIST_TEMPLATE';
export const LIBRARY_ITEM_OPEN_RIGHT_COLUMN = 'LIBRARY_ITEM_OPEN_RIGHT_COLUMN';
export const LIBRARY_ITEM_CLOSE_RIGHT_COLUMN =
  'LIBRARY_ITEM_CLOSE_RIGHT_COLUMN';
export const LIBRARY_ITEM_SET_ITEM_DETAIL = 'LIBRARY_ITEM_SET_ITEM_DETAIL';
export const LIBRARY_ITEM_ON_CLICK_CANCEL = 'LIBRARY_ITEM_ON_CLICK_CANCEL';
export const LIBRARY_ITEM_ON_DROP_IMAGE = 'LIBRARY_ITEM_ON_DROP_IMAGE';
export const LIBRARY_ITEM_ON_DELETE_IMAGE = 'LIBRARY_ITEM_ON_DELETE_IMAGE';
export const LIBRARY_ITEM_ON_CLICK_BTN_ITEM_VARIANT =
  'LIBRARY_ITEM_ON_CLICK_BTN_ITEM_VARIANT';
export const LIBRARY_ITEM_SHOW_ITEM_VARIANT_MODAL =
  'LIBRARY_ITEM_SHOW_ITEM_VARIANT_MODAL';
export const LIBRARY_ITEM_HIDE_ITEM_VARIANT_MODAL =
  'LIBRARY_ITEM_HIDE_ITEM_VARIANT_MODAL';
export const LIBRARY_ITEM_SET_PREVIOUS_ITEM_FORM =
  'LIBRARY_ITEM_SET_PREVIOUS_ITEM_FORM';
export const LIBRARY_ITEM_ON_CANCEL_ITEM_VARIANT_MODAL =
  'LIBRARY_ITEM_ON_CANCEL_ITEM_VARIANT_MODAL';
export const LIBRARY_ITEM_ON_CONFIRM_ITEM_VARIANT_MODAL =
  'LIBRARY_ITEM_ON_CONFIRM_ITEM_VARIANT_MODAL';
export const LIBRARY_ITEM_ON_CONFIRM_SALES_TYPE_MODAL =
  'LIBRARY_ITEM_ON_CONFIRM_SALES_TYPE_MODAL';
export const LIBRARY_ITEM_ON_CLICK_BTN_SALES_TYPE =
  'LIBRARY_ITEM_ON_CLICK_BTN_SALES_TYPE';
export const LIBRARY_ITEM_SHOW_SALES_TYPE_MODAL =
  'LIBRARY_ITEM_SHOW_SALES_TYPE_MODAL';
export const LIBRARY_ITEM_HIDE_SALES_TYPE_MODAL =
  'LIBRARY_ITEM_HIDE_SALES_TYPE_MODAL';
export const LIBRARY_ITEM_ON_CANCEL_SALES_TYPE_MODAL =
  'LIBRARY_ITEM_ON_CANCEL_SALES_TYPE_MODAL';
export const LIBRARY_ITEM_SHOW_ITEM_INVENTORY_ALERT_MODAL =
  'LIBRARY_ITEM_SHOW_ITEM_INVENTORY_ALERT_MODAL';
export const LIBRARY_ITEM_HIDE_ITEM_INVENTORY_ALERT_MODAL =
  'LIBRARY_ITEM_HIDE_ITEM_INVENTORY_ALERT_MODAL';
export const LIBRARY_ITEM_SHOW_COGS_MODAL = 'LIBRARY_ITEM_SHOW_COGS_MODAL';
export const LIBRARY_ITEM_HIDE_COGS_MODAL = 'LIBRARY_ITEM_HIDE_COGS_MODAL';
export const LIBRARY_ITEM_ON_CLICK_BTN_ITEM_TRACKING =
  'LIBRARY_ITEM_ON_CLICK_BTN_ITEM_TRACKING';
export const LIBRARY_ITEM_ON_CLICK_BTN_COGS_TRACKING =
  'LIBRARY_ITEM_ON_CLICK_BTN_COGS_TRACKING';
export const LIBRARY_ITEM_ON_CANCEL_ITEM_INVENTORY_ALERT_MODAL =
  'LIBRARY_ITEM_ON_CANCEL_ITEM_INVENTORY_ALERT_MODAL';
export const LIBRARY_ITEM_ON_CONFIRM_COGS_MODAL =
  'LIBRARY_ITEM_ON_CONFIRM_COGS_MODAL';
export const LIBRARY_ITEM_ON_CANCEL_COGS_MODAL =
  'LIBRARY_ITEM_ON_CANCEL_COGS_MODAL';
export const LIBRARY_ITEM_ON_CONFIRM_ITEM_INVENTORY_ALERT_MODAL =
  'LIBRARY_ITEM_ON_CONFIRM_ITEM_INVENTORY_ALERT_MODAL';
export const LIBRARY_ITEM_FILL_FORM_DETAIL_ITEM =
  'LIBRARY_ITEM_FILL_FORM_DETAIL_ITEM';
export const LIBRARY_ITEM_SET_MODIFIER_FOR_DETAIL_ITEM =
  'LIBRARY_ITEM_SET_MODIFIER_FOR_DETAIL_ITEM';
export const LIBRARY_ITEM_SET_MODIFIERS = 'LIBRARY_ITEM_SET_MODIFIERS';
export const LIBRARY_ITEM_SET_ACTIVE_MODIFIER_IDS =
  'LIBRARY_ITEM_SET_ACTIVE_MODIFIER_IDS';
export const LIBRARY_ITEM_SET_MANAGE_ITEM_INVENTORY =
  'LIBRARY_ITEM_SET_MANAGE_ITEM_INVENTORY';
export const LIBRARY_ITEM_SUBMIT_FORM_CREATE = `LIBRARY_ITEM_SUBMIT_FORM_CREATE`;
export const LIBRARY_ITEM_SUBMIT_FORM_UPDATE = `LIBRARY_ITEM_SUBMIT_FORM_UPDATE`;
export const LIBRARY_ITEM_SHOW_UPDATE_MODAL = `LIBRARY_ITEM_SHOW_UPDATE_MODAL`;
export const LIBRARY_ITEM_HIDE_UPDATE_MODAL = `LIBRARY_ITEM_HIDE_UPDATE_MODAL`;
export const LIBRARY_ITEM_SHOW_DELETE_MODAL = `LIBRARY_ITEM_SHOW_DELETE_MODAL`;
export const LIBRARY_ITEM_HIDE_DELETE_MODAL = `LIBRARY_ITEM_HIDE_DELETE_MODAL`;
export const LIBRARY_ITEM_DELETE_ITEM = `LIBRARY_ITEM_DELETE_ITEM`;
export const LIBRARY_ITEM_ON_CLICK_CREATE_NEW_CATEGORY = `LIBRARY_ITEM_ON_CLICK_CREATE_NEW_CATEGORY`;
export const LIBRARY_ITEM_ON_CLICK_CREATE_NEW_BRAND = `LIBRARY_ITEM_ON_CLICK_CREATE_NEW_BRAND`;
export const LIBRARY_ITEM_CREATE_CATEGORY_SHOW_MODAL = `LIBRARY_ITEM_CREATE_CATEGORY_SHOW_MODAL`;
export const LIBRARY_ITEM_CREATE_BRAND_SHOW_MODAL = `LIBRARY_ITEM_CREATE_BRAND_SHOW_MODAL`;
export const LIBRARY_ITEM_CREATE_BRAND_HIDE_MODAL = `LIBRARY_ITEM_CREATE_BRAND_HIDE_MODAL`;
export const LIBRARY_ITEM_CREATE_CATEGORY_HIDE_MODAL = `LIBRARY_ITEM_CREATE_CATEGORY_HIDE_MODAL`;
export const LIBRARY_ITEM_CONFIRM_CREATE_NEW_CATEGORY = `LIBRARY_ITEM_CONFIRM_CREATE_NEW_CATEGORY`;
export const LIBRARY_ITEM_CONFIRM_CREATE_NEW_BRAND = `LIBRARY_ITEM_CONFIRM_CREATE_NEW_BRAND`;
export const LIBRARY_ITEM_CANCEL_CREATE_NEW_CATEGORY = `LIBRARY_ITEM_CANCEL_CREATE_NEW_CATEGORY`;
export const LIBRARY_ITEM_SET_PREVIOUS_CATEGORIES = `LIBRARY_ITEM_SET_PREVIOUS_CATEGORIES`;
export const LIBRARY_ITEM_SET_PREVIOUS_BRAND = `LIBRARY_ITEM_SET_PREVIOUS_BRAND`;
export const LIBRARY_ITEM_SET_PREVIOUS_CATEGORY_ID = `LIBRARY_ITEM_SET_PREVIOUS_CATEGORY_ID`;
export const LIBRARY_ITEM_SET_PREVIOUS_BRAND_ID = `LIBRARY_ITEM_SET_PREVIOUS_BRAND_ID`;
export const LIBRARY_ITEM_SET_NEW_CATEGORY = `LIBRARY_ITEM_SET_NEW_CATEGORY`;
export const LIBRARY_ITEM_SET_NEW_BRAND = `LIBRARY_ITEM_SET_NEW_BRAND`;
export const LIBRARY_ITEM_SHOW_IMPORT_MODAL = `LIBRARY_ITEM_SHOW_IMPORT_MODAL`;
export const LIBRARY_ITEM_HIDE_IMPORT_MODAL = `LIBRARY_ITEM_HIDE_IMPORT_MODAL`;
export const LIBRARY_ITEM_ON_SUCCESS_IMPORT = `LIBRARY_ITEM_ON_SUCCESS_IMPORT`;
export const LIBRARY_ITEM_SHOW_SAVE_TO_ALL_OUTLETS_MODAL = `LIBRARY_ITEM_SHOW_SAVE_TO_ALL_OUTLETS_MODAL`;
export const LIBRARY_ITEM_HIDE_SAVE_TO_ALL_OUTLETS_MODAL = `LIBRARY_ITEM_HIDE_SAVE_TO_ALL_OUTLETS_MODAL`;
export const LIBRARY_ITEM_SET_MUST_SCROLL_TOP = `LIBRARY_ITEM_SET_MUST_SCROLL_TOP`;
export const LIBRARY_ITEM_SET_IS_SUBMITTING_FORM = `LIBRARY_ITEM_SET_IS_SUBMITTING_FORM`;
export const LIBRARY_ITEM_SET_REWARD_ITEM_LIST = `LIBRARY_ITEM_SET_REWARD_ITEM_LIST`;
export const LIBRARY_ITEM_SET_REWARD_CATEGORY_LIST = `LIBRARY_ITEM_SET_REWARD_CATEGORY_LIST`;
export const LIBRARY_ITEM_SET_REWARD_ITEM_VARIANT_OF = `LIBRARY_ITEM_SET_REWARD_ITEM_VARIANT_OF`;
export const LIBRARY_ITEM_SET_POINT_GAIN_ITEM_LIST = `LIBRARY_ITEM_SET_POINT_GAIN_ITEM_LIST`;
export const LIBRARY_ITEM_SET_POINT_GAIN_CATEGORY_LIST = `LIBRARY_ITEM_SET_POINT_GAIN_CATEGORY_LIST`;
export const LIBRARY_ITEM_SET_POINT_GAIN_ITEM_VARIANT_OF = `LIBRARY_ITEM_SET_POINT_GAIN_ITEM_VARIANT_OF`;
export const LIBRARY_ITEM_ON_REDIRECT_SALES_TYPE = `LIBRARY_ITEM_ON_REDIRECT_SALES_TYPE`;
export const LIBRARY_ITEM_SET_VALIDATION_MODAL = `LIBRARY_ITEM_SET_VALIDATION_MODAL`;
export const LIBRARY_ITEM_SET_VALIDATION_MODAL_MESSAGE = `LIBRARY_ITEM_SET_VALIDATION_MODAL_MESSAGE`;
export const LIBRARY_ITEM_ITEM_LIST_EXPORT_START = `LIBRARY_ITEM_ITEM_LIST_EXPORT_START`;
export const LIBRARY_ITEM_ITEM_LIST_EXPORT_FINISHED = `LIBRARY_ITEM_ITEM_LIST_EXPORT_FINISHED`;
export const LIBRARY_ITEM_ITEM_LIST_EXPORT_ERROR = `LIBRARY_ITEM_ITEM_LIST_EXPORT_ERROR`;
export const LIBRARY_ITEM_SET_BRAND_LIST = 'LIBRARY_ITEM_SET_BRAND_LIST';
export const LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_CONSTRUCT_DATA = `LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_CONSTRUCT_DATA`;
export const LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_COLOR_DATA = `LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_COLOR_DATA`;
export const LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_COLOR_DATA_NO_SAGA = `LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_COLOR_DATA_NO_SAGA`;
export const LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_COLOR_DATA = `LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_COLOR_DATA`;
export const LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_COLOR_ALL_DATA = `LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_COLOR_ALL_DATA`;
export const LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_COLOR_ALL_DATA_NO_SAGA = `LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_COLOR_ALL_DATA_NO_SAGA`;
export const LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_COLOR_INPUT = `LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_COLOR_INPUT`;
export const LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_SIZE_DATA = `LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_SIZE_DATA`;
export const LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_SIZE_DATA_NO_SAGA = `LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_SIZE_DATA_NO_SAGA`;
export const LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_SIZE_DATA = `LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_SIZE_DATA`;
export const LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_SIZE_ALL_DATA = `LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_SIZE_ALL_DATA`;
export const LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_SIZE_ALL_DATA_NO_SAGA = `LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_SIZE_ALL_DATA_NO_SAGA`;
export const LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_SIZE_INPUT = `LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_SIZE_INPUT`;
export const LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_MATERIAL_DATA = `LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_MATERIAL_DATA`;
export const LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_MATERIAL_DATA_NO_SAGA = `LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_MATERIAL_DATA_NO_SAGA`;
export const LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_MATERIAL_ALL_DATA = `LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_MATERIAL_ALL_DATA`;
export const LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_MATERIAL_DATA = `LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_MATERIAL_DATA`;
export const LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_MATERIAL_ALL_DATA = `LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_MATERIAL_ALL_DATA`;
export const LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_MATERIAL_ALL_DATA_NO_SAGA = `LIBRARY_ITEM_UNSET_CUSTOM_CATEGORY_FASHION_MATERIAL_ALL_DATA_NO_SAGA`;
export const LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_MATERIAL_INPUT = `LIBRARY_ITEM_SET_CUSTOM_CATEGORY_FASHION_MATERIAL_INPUT`;
export const LIBRARY_ITEM_SHOW_UPDATE_ALL_OUTLET_MODAL = `LIBRARY_ITEM_SHOW_UPDATE_ALL_OUTLET_MODAL`;
export const LIBRARY_ITEM_HIDE_UPDATE_ALL_OUTLET_MODAL = `LIBRARY_ITEM_HIDE_UPDATE_ALL_OUTLET_MODAL`;
export const LIBRARY_ITEM_SHOW_ERROR_UPDATE_ALL_OUTLET_MODAL = `LIBRARY_ITEM_SHOW_ERROR_UPDATE_ALL_OUTLET_MODAL`;
export const LIBRARY_ITEM_HIDE_ERROR_UPDATE_ALL_OUTLET_MODAL = `LIBRARY_ITEM_HIDE_ERROR_UPDATE_ALL_OUTLET_MODAL`;

export const LIBRARY_VALIDATION_NAME_MESSAGE = {
  NO_ERROR: 0,
  NAME_NOT_UNIQUE: 1,
  SALES_TYPE_NOT_EXIST: 2,
  BOTH: 3,
};
